import { IconButton, Stack, Typography } from '@mui/material'
import { useMemo } from 'react'
import { SvgAsset } from '~/components/SvgAsset'
import { getLanguageLocalStorage } from '~/features/i18n/utils/languageLocalStorage'
import * as GA from '~/libs/ga'
import { Colors } from '~/libs/mui/theme'
import { useOnClickLikeButton } from '../../VideoInfo/useOnClickLikeButton'

interface VideoLikeButtonProps {
  likeNum: number
  hasLike: boolean
  videoId: string
}

const useFormattedNumber = (number: number, lang: string): string => {
  return useMemo(() => {
    const formatter = new Intl.NumberFormat(lang, {
      notation: 'compact',
      compactDisplay: 'short',
    })
    return formatter.format(number)
  }, [lang, number])
}

export function VideoLikeButton({ likeNum, hasLike, videoId }: VideoLikeButtonProps): JSX.Element {
  const onClickLikeButton = useOnClickLikeButton(videoId, hasLike, () => {
    GA.sendEvent({
      event: 'click',
      screen: 'stream',
      category: 'icon',
      action: 'stream_poster_like',
      label: `${videoId}`,
    })
  })
  const lang = getLanguageLocalStorage()
  const formatLikeNum = useFormattedNumber(likeNum, lang ?? 'en')
  return (
    <Stack direction='row' spacing={0} alignItems='center' fontSize='12px'>
      <IconButton
        size='small'
        sx={{
          color: `${hasLike ? Colors.yellow : Colors.color5A5957}`,
          minHeight: 0,
        }}
        onClick={() => {
          onClickLikeButton()
        }}
      >
        <SvgAsset asset='like' fontSize='small' />
      </IconButton>
      <Typography variant='caption' color='white'>
        {likeNum && formatLikeNum}
      </Typography>
    </Stack>
  )
}
